import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import filterProps from '../../../utils/filterProps';
import { PullRequestMetrics } from '../components/PullRequestMetrics';
import { PrMetricsSummary } from '../components/PrMetricsSummary';
class PrMetrics extends Component {
    getLink(repositoryIds = null) {
        const { isClickable } = this.props;
        let link;
        if (isClickable) {
            const repositories = Array.isArray(repositoryIds) ? encodeURIComponent(repositoryIds.join(',')) : '';
            link = '/velocity-report' + (Array.isArray(repositoryIds) ? '?repositories=' + repositories : '');
        }
        return link;
    }
    render() {
        const { activeRepositoriesIds, from, to, loading, showTimeInfo, user } = filterProps(this.props, ['repositories', 't']);
        const link = this.getLink(activeRepositoriesIds);
        if (loading) {
            return _jsx(PrMetricsSummary, { loading: true, link: link, from: from ?? null, to: to ?? null, showTimeInfo: showTimeInfo, user: user });
        }
        return _jsx(PullRequestMetrics, { timezoneId: user.user.timezoneId, activeRepositoriesIds: activeRepositoriesIds, from: from, to: to, link: link, pollInterval: user.user?.isLoadingPrOrRepositories ? 3000 : 0, showTimeInfo: showTimeInfo, user: user });
    }
}
PrMetrics.defaultProps = {
    loading: false,
    showTimeInfo: false,
    isClickable: false,
};
const mapStateToProps = (state) => ({
    user: state.user,
});
// @ts-expect-error TS2693: 'ComponentType' only refers to a type, but is being used as a value here.
export default connect(mapStateToProps)(withRouter(withTranslation()(PrMetrics)));
